import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';

// Components
import TingEssentialDetails from './TingEssentialDetails';
import TingLocationDetails from './TingLocationDetails';
import TingContentDetails from './TingContentDetails';
import TingSocialDetails from './TingSocialDetails';
import './TingEditor.css';

export default function EditTing() {
    const sections = [
        {
            key: 'core',
            title: 'Core Sighting Details',
            subtitle: 'Update the timing, species and main sighting notes.',
            icon: <EditOutlinedIcon fontSize="small" />,
            component: <TingEssentialDetails />
        },
        {
            key: 'location',
            title: 'Location & Mapping',
            subtitle: 'Adjust GPS coordinates and refresh road/location suggestions.',
            icon: <LocationOnOutlinedIcon fontSize="small" />,
            component: <TingLocationDetails />
        },
        {
            key: 'content',
            title: 'Content Metadata',
            subtitle: 'Review the asset type and linked media files.',
            icon: <DescriptionOutlinedIcon fontSize="small" />,
            component: <TingContentDetails />
        },
        {
            key: 'social',
            title: 'Social Context',
            subtitle: 'Check engagement counters and tinger ownership details.',
            icon: <GroupOutlinedIcon fontSize="small" />,
            component: <TingSocialDetails />
        }
    ];

    return (
        <div className="ting-editor">
            {sections.map((section) => (
                <Paper key={section.key} elevation={0} className="ting-editor__section">
                    <div className="ting-editor__section-header">
                        <span className="ting-editor__section-icon">
                            {section.icon}
                        </span>
                        <div>
                            <Typography variant="h6">{section.title}</Typography>
                            <Typography variant="body2" className="ting-editor__section-subtitle">
                                {section.subtitle}
                            </Typography>
                        </div>
                    </div>
                    <div className="ting-editor__section-content">
                        {section.component}
                    </div>
                </Paper>
            ))}
        </div>
    );
}
